import { EkeyUserModel } from "@courses-models/user";

/**
 * Extend the base EkeyUserModel, making sure that the authentication token is
 * exposed publicly.
 */
export class AuthenticatedEkeyUserModel extends EkeyUserModel {
    /**
     * Contains information about the authentication of this user.
     */
    public readonly auth: {
        /**
         * Specifies which LoginConnector profile was used, when the user was
         * being authenticated.
         */
        readonly profile: string;

        /**
         * Specifies the token returned by the LoginConnector, when the user was
         * being authenticated.
         */
        readonly token: string;
    };

    /**
     * Cache data from the base user model and save the token as well, when a
     * new instance of the AuthenticatedEkeyUserModel is created.
     */
    constructor(base: EkeyUserModel, auth: { profile: string; token: string }) {
        super({
            ekeyId: base.ekeyId,
            id: base.id,
            mail: base.mail,
            name: base.name,
        });

        this.auth = auth;
    }
}
